






















import { useRoute, defineComponent, ref, useContext, onMounted } from '@nuxtjs/composition-api';
import type { Route } from 'vue-router';
import PageLoading from '~/components/GlobalComponents/PageLoading.vue';
import Footer from '~/components/solepro/Footer.vue';
import Header from '~/components/solepro/Header.vue';
import { SOLEPRO_LINKS, SOLEPRO_SCRIPTS, SOLEPRO_TITLE, SOLEPRO_META } from '~/utils/constants/nuxt/metaInfos';
import ClientOnly from 'vue-client-only';
import axios from 'axios';
import { useConfig, useUiNotification, useUser } from '~/composables';
import { getUserIsLogged } from '~/helpers/user/user';
import { getAxiosConfigs, isElementInViewport } from '~/utils/solepro/functions';
import Notification from '~/components/Notification.vue';
import { ADD_TO_WISHLIST_ICON_ANIMATION } from '~/utils/constants/layout';


export default defineComponent({
  name: 'SoleproLayout',
  components: {
    PageLoading,
    Notification,
    Header,
    Footer,
    ClientOnly
  },
  head() {
    const pageParam = ((this.route as Route).query.page && (this.route as Route).query.page !== '0' && (this.route as Route).query.page !== '1') ? (this.route as Route).query.page : null;
    return {
      htmlAttrs: {
        lang: 'it'
      },
      titleTemplate: SOLEPRO_TITLE,
      link: [...SOLEPRO_LINKS, { rel: 'canonical', hid: 'canonical', href: `${(this.config as any).soleproDomain}${(this.route as Route).path}${pageParam ? `?page=${pageParam}` : ''}` }],
      script: SOLEPRO_SCRIPTS,
      meta: SOLEPRO_META
    };
  },
  setup() {
    const { app, $cookies } = useContext();
    const { $config } = app;
    const { config: storeConfig } = useConfig()
    const route = useRoute();
    const hasBorder = ref(false);
    const { afterLogin } = useUser()
    const { send: sendNotification } = useUiNotification();

    /* 
        1. verifico se  l'utente è loggato sul DU
        2. se è loggato cerco l'utente su Magento tramite il suo X-Username che si trova nell'header di tutte le chiamate (in locale c'è il mock sul runtime config)
          2.1. se l'utente esiste setto il customer tokem e il cart token (@TODO verificare se serve altro)
          2.2 se non esiste creo l'utente
    */
    onMounted(async () => {
       if(route.value.query['ErrMsg']){
        sendNotification({
                id: Symbol('login_error'),
                message: "Accesso non riuscito. Email o password non validi.",
                persist: true,
                type: 'danger',
                icon: '',
                position: 'top-right'
            });
            window.history.replaceState({url:window.location.pathname}, null, window.location.pathname)
      }

      
      
      const isAuthenticated = getUserIsLogged($cookies)
      if (!isAuthenticated) return;
      const { data } = await axios.post(`/sole-api/user/me`)
      if (data?.token) {
        await afterLogin(data.token)
      } else {
        const { data } = await axios.post(`/sole-api/user/register-after-du`, {}, { ...getAxiosConfigs(app, storeConfig) })
      }
      
      const actions = $cookies.get('pendingActions') || [];
      actions.forEach(action => {
        switch (action.name) {
          case 'addToWishlist':
            try {
              const addToWishlistBtn = Array.from(document.querySelectorAll(`.js-add-to-wishlist[data-sku="${action.data}"]`)).find(el=>isElementInViewport(el)) as HTMLElement;
              const isActive = addToWishlistBtn.getAttribute('data-active');
              (!isActive || isActive === 'false') && addToWishlistBtn.click();
            } catch (e) {
              console.error('Errore esecuzione pemnding action', e)
            }
            break;
          default:
            break;
        }
      })
      $cookies.remove('pendingActions')

    })

    return {
      route,
      config: $config,
      hasBorder
    };
  },
});
